/** @jsxImportSource theme-ui */
import React from 'react'
import { withPageProps } from '~/api/services'
import { getServerSession } from 'next-auth/next'
import { authOptions } from '../api/auth/[...nextauth]'
import AccountForm from '~/components/Account/AccountForm'
import SEO from '~/components/SEO'

const Login: React.FC = () => {
  return (
    <>
      <SEO
        title={`PenguinCBD Account`}
        description="Sign in to Penguin to manage your subscriptions, shipping address, &amp; more."
      />
      <AccountForm />
    </>
  )
}

export default Login

export async function getServerSideProps(context:any) {
  const session = await getServerSession(context.req, context.res, authOptions)
  if (session) {
    return {
      redirect: {
        destination: '/account',
        permanent: false,
      },
    }
  }
  const props = await withPageProps({
    headerProps: {
      sticky: true,
    },
  })
  return {
    props: {
      ...props,
      session,
    },
  }
}
